import styled from 'styled-components';
import { BoxProps, ItemProps } from './interfaces';

const Column = styled.div<BoxProps & ItemProps>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent ?? 'flex-start'};
  align-items: ${(props) => props.alignItems ?? null};
  flex-grow: ${(props) => props.flexGrow ?? 0};
  flex-shrink: ${(props) => `${props.flexShrink}`};
  flex-basis: ${(props) => props.flexBasis};
  overflow: ${(props) => props.overflow ?? 'auto'};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: ${(props) => props.padding};
  background-color: ${(props) => props.backgroundColor};
  align-self: ${(props) => (props.alignSelf ? 'auto' : null)};
`;

export default Column;
